/* eslint-disable */
/* eslint-disable no-param-reassign */
<template>
  <PaymentOrderRestaurant v-if="$store.getters['theme/isRestaurantEnabled']" />
  <PaymentOrderPickup v-else />
</template>

<script>
import comminMixin from "../mixins/common";
import PaymentOrderRestaurant from "./PaymentOrderRestaurant.vue";
import PaymentOrderPickup from "./PaymentOrderPickup.vue";

export default {
  mixins: [comminMixin],
  components: {
    PaymentOrderPickup,
    PaymentOrderRestaurant,
  },
  data: () => ({
    key: "payment",
  }),
  async mounted() {},
  methods: {},
  computed: {},
  watch: {},
};
</script>
